<template>
  <v-container fluid>
    <v-sheet style="overflow-y: auto; overflow-x: hidden" :height="$store.state.windowSize.y - 110">
      <v-row>
        <v-col cols="4">
          <v-card>
            <v-card-title>{{ $t('label.systemSettings') }}</v-card-title>
            <v-card-text>
              <v-btn class="mb-3" @click="dialogLicenseString = true" block>{{ $t('btn.showLicense') }}</v-btn>
              <v-btn class="mb-3" @click="dialogSMTP = true" block>{{ $t('btn.settingsSMTP') }}</v-btn>
              <v-tooltip bottom :open-delay="750">
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-checkbox v-model="settings.telemetry" :label="$t('label.sendTelemetryData')" hide-details />
                  </div>
                </template>
                <span>{{ $t('tt.sendTelemetryData') }}</span>
              </v-tooltip>
              <br />
              <h3>{{ $t('label.dataValidation') }}</h3>
              <v-tooltip bottom :open-delay="750">
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-checkbox
                      class="mt-0 pt-0"
                      v-model="settings.checkDocumentValidity"
                      :label="$t('label.checkDocumentValidity')"
                      hide-details
                    />
                  </div>
                </template>
                <span> {{ $t('tt.checkDocumentValidity') }} </span>
              </v-tooltip>
              <v-tooltip bottom :open-delay="750">
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-checkbox class="mt-0 pt-0" v-model="settings.autoOrgID" :label="$t('label.autoGenerateID')" hide-details />
                  </div>
                </template>
                <span v-html="$t('tt.autoGenerateID')" />
              </v-tooltip>
              <br />
              <!--v-tooltip bottom :open-delay="750">
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-row>
                      <v-col>
                        <h3>{{ $t('label.warningTemperature') }}</h3>
                        <v-select
                          v-model="settings.temperature"
                          height="25"
                          :items="listTemperatures"
                          item-text="text"
                          item-value="value"
                          :prepend-icon="mdiThermometer"
                          :label="$t('label.temperature')"
                          hide-details
                          autocomplete="off"
                        />
                      </v-col>
                    </v-row>
                  </div>
                </template>
                <span>{{ $t('tt.warningTemperature') }}</span>
              </v-tooltip-->
              <hr />
              <br />
              <h3>{{ $t('label.autoSave') }}</h3>
              <v-tooltip bottom :open-delay="750">
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-checkbox class="mt-0 pt-0" v-model="settings.autoSaveVisitors" :label="$t('label.autoSaveVisitors')" hide-details />
                  </div>
                </template>
                <span v-html="$t('tt.autoSaveVisitors')" />
              </v-tooltip>
              <v-tooltip bottom :open-delay="750">
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-checkbox
                      class="mt-0 pt-0"
                      v-model="settings.autoSaveCompanies"
                      :label="$t('label.autoSaveCompanies')"
                      hide-details
                    />
                  </div>
                </template>
                <span v-html="$t('tt.autoSaveCompanies')" />
              </v-tooltip>
              <v-tooltip bottom :open-delay="750">
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-checkbox class="mt-0 pt-0" v-model="settings.autoSaveCars" :label="$t('label.autoSaveCars')" hide-details />
                  </div>
                </template>
                <span v-html="$t('tt.autoSaveCars')" />
              </v-tooltip>
              <hr />
              <br />
              <h3>{{ $t('label.planningVisits') }}</h3>
              <v-tooltip bottom :open-delay="750">
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-checkbox class="mt-0 pt-0" v-model="settings.planVisits" :label="$t('label.planningVisits')" hide-details />
                  </div>
                </template>
                <span v-html="$t('tt.planningVisits')" />
              </v-tooltip>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="4">
          <v-card>
            <v-tooltip bottom :open-delay="750">
              <template v-slot:activator="{ on }">
                <v-card-title v-on="on">{{ $t('label.userDefinedVisitorFields') }}</v-card-title>
              </template>
              <span v-html="$t('tt.userDefinedVisitorFields')" />
            </v-tooltip>
            <v-card-text>
              <v-text-field
                :label="`${$t('label.userDefinedField')} 1`"
                maxlength="32"
                v-model="settings.usrDef1name"
                hide-details
                clearable
              />
              <v-text-field
                :label="`${$t('label.userDefinedField')} 2`"
                maxlength="32"
                v-model="settings.usrDef2name"
                hide-details
                clearable
              />
              <v-text-field
                :label="`${$t('label.userDefinedField')} 3`"
                maxlength="32"
                v-model="settings.usrDef3name"
                hide-details
                clearable
              />
              <v-text-field
                :label="`${$t('label.userDefinedField')} 4`"
                maxlength="32"
                v-model="settings.usrDef4name"
                hide-details
                clearable
              />
            </v-card-text>
          </v-card>
          <v-card class="mt-2">
            <v-tooltip bottom :open-delay="750">
              <template v-slot:activator="{ on }">
                <v-card-title v-on="on">{{ $t('label.localSettings') }}</v-card-title>
              </template>
              <span v-html="$t('tt.userDefinedVisitorFields')" />
            </v-tooltip>
            <v-card-text>
              <v-select
                v-model="settings.language"
                :items="listLanguages"
                item-text="text"
                item-value="value"
                :label="$t('label.languageDefault')"
                hide-details
              />
              <v-select
                v-model="settings.formatDate"
                :items="listDateFormats"
                item-text="text"
                item-value="value"
                :label="$t('label.formatDate')"
                hide-details
              />
              <v-select
                v-model="settings.formatTime"
                :items="listTimeFormats"
                item-text="text"
                item-value="value"
                :label="$t('label.formatTime')"
                hide-details
              />
              <v-select
                v-model="settings.firstDay"
                :items="listFirstDayOfWeek"
                item-text="text"
                item-value="value"
                :label="$t('label.firstDayOfWeek')"
                hide-details
              />
              <v-autocomplete
                v-model="settings.timezone"
                :items="listTimezones"
                item-text="text"
                item-value="value"
                :label="$t('label.timezoneDefault')"
                hide-details
              />
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="4">
          <v-card>
            <v-card-title>{{ $t('label.settingsAdditional') }}</v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-tooltip bottom :open-delay="750">
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-text-field :label="$t('label.mobileGateway')" v-model="settings.mobileGateway" hide-details clearable />
                      </div>
                    </template>
                    <span v-html="$t('tt.mobileGateway')" />
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-row v-if="$store.state.auth.userSettings.accArchive.import && $store.state.auth.userSettings.allowImport">
                <v-col>
                  <v-btn block color="colorImport" @click="modalImport = true">{{ $t('label.importArchive') }}</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card class="mt-2">
            <v-card-title>{{ $t('label.api') }}</v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-tooltip bottom :open-delay="750">
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-checkbox v-model="settings.apiEnabled" :label="$t('label.apiEnabled')" hide-details />
                      </div>
                    </template>
                    <span>{{ $t('tt.apiEnabled') }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-textarea v-model="settings.apiToken" :label="$t('label.apiKey')" hide-details />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-btn block @click="generateToken">{{ $t('btn.generate') }}</v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn block @click="copyToClipboard(settings.apiToken)">{{ $t('btn.copy') }}</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-sheet>
    <v-row>
      <v-col>
        <v-btn block color="colorSave" @click="dataSave">{{ $t('btn.save') }}</v-btn>
      </v-col>
    </v-row>
    <!----MODALY----------------------------------------------------------------------->
    <v-dialog v-model="modalImport" max-width="60vw">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>{{ $t('label.import') }}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-select v-model="importEvent" label="Akce:" :items="listImportEvents" hide-details append-icon auto-select-first />
            </v-col>
            <v-spacer />
            <v-col cols="2">
              <v-progress-circular v-if="importProgressStatus" :size="40" color="green" indeterminate />
            </v-col>
            <v-col cols="3">
              <v-btn block color="colorImport" class="mt-2">
                <label for="appLogFileInput">{{ $t('btn.csvFile') }}</label>
                <input
                  id="appLogFileInput"
                  v-on:change="((importFile = $event.target.files), (importFileName = $event.target.files[0].name))"
                  type="file"
                  hidden
                />
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <h3>{{ importFileName }}</h3>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn color="colorImport" @click="uploadArchive">{{ $t('btn.import') }}</v-btn>
          <v-spacer />
          <v-btn color="colorClose" @click="modalImport = false">{{ $t('btn.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogLicenseString" max-width="80vw">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $t('label.licenseKey') }}
          <v-spacer />
          <v-icon large @click="dialogLicenseString = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col class="mt-3 pb-0" cols="3">
              <h3>{{ $t('label.UUID') }}</h3>
            </v-col>
            <v-col class="mt-3 pb-0" cols="6">
              <h3>{{ settings.installUUID }}</h3>
            </v-col>
            <v-col cols="1" class="pt-4">
              <v-btn icon @click="copyToClipboard(settings.installUUID)">
                <v-icon>{{ mdiClipboard }}</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="my-0">
            <v-col class="mt-3 pb-0" cols="2">
              <h3>{{ $tc('label.workplace', 1) }}</h3>
            </v-col>
            <v-col class="mt-3 pb-0" cols="2">
              <h3>{{ settings.licWorkplaces }}</h3>
            </v-col>
            <v-col class="mt-3 pb-0" cols="2">
              <h3>{{ $t('label.planning') }}</h3>
            </v-col>
            <v-col class="mt-3 pb-0" cols="2">
              <v-icon v-if="settings.licPlanning" color="green">{{ mdiCheck }}</v-icon>
              <v-icon v-else color="red">{{ mdiClose }}</v-icon>
            </v-col>
            <v-col class="mt-3 pb-0" cols="2">
              <h3>{{ $t('label.expire') }}</h3>
            </v-col>
            <v-col class="mt-3 pb-0" cols="2">
              <h3>{{ licTimecalc() }}</h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea v-model="settings.licenseString" :label="$t('label.licenseKey')" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn color="colorSave" @click="dataSave">{{ $t('btn.save') }}</v-btn>
          <v-spacer />
          <v-btn color="colorClose" @click="dialogLicenseString = false">{{ $t('btn.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSMTP" max-width="60vw">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $t('label.smtpSettings') }}
          <v-spacer />
          <v-icon large @click="dialogSMTP = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col class="pb-0" cols="8">
              <v-text-field :label="$t('label.smtpServer')" maxlength="256" v-model="settings.smtpServer" hide-details clearable />
            </v-col>
            <v-col class="pb-0" cols="4">
              <v-text-field :label="$t('label.smtpPort')" type="number" v-model.number="settings.smtpPort" hide-details clearable />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0" cols="4">
              <v-select
                v-model="settings.smtpTLS"
                :items="listTLS"
                item-text="text"
                item-value="value"
                :label="$t('label.smtpTLS')"
                hide-details
                autocomplete="off"
              />
            </v-col>
            <v-col class="py-0" cols="4">
              <v-checkbox v-model="settings.smtpTLSvalid" :label="$t('label.smtpTLSvalidation')" hide-details />
            </v-col>
            <v-col class="py-0" cols="4">
              <v-select
                v-model="settings.smtpAuth"
                :items="listAuth"
                item-text="text"
                item-value="value"
                :label="$t('label.smtpAuth')"
                hide-details
                autocomplete="off"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0" cols="6">
              <v-text-field :label="$t('label.smtpUser')" v-model="settings.smtpUser" hide-details clearable />
            </v-col>
            <v-col class="py-0" cols="6">
              <v-text-field :label="$t('label.smtpPassword')" type="password" v-model="settings.smtpPassword" hide-details clearable />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0" cols="8">
              <v-text-field :label="$t('label.smtpSender')" v-model="settings.smtpSender" hide-details clearable />
            </v-col>
            <v-col class="pt-0" cols="4">
              <v-checkbox v-model="settings.smtpEnabled" :label="$t('label.smtpActive')" hide-details />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <v-text-field :label="$t('label.publicServerAddress')" v-model="settings.publicServerAddress" hide-details clearable />
            </v-col>
          </v-row>
          <v-divider class="my-3" />
          <v-row>
            <v-col class="py-0">
              <h3>{{ $t('label.smtpTestEmail') }}</h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0" cols="6">
              <v-text-field v-model="testEmail.to" :label="$t('label.email')" hide-details />
            </v-col>
            <v-col class="py-0" cols="6">
              <v-text-field v-model="testEmail.subject" :label="$t('label.subject')" hide-details />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0">
              <v-text-field v-model="testEmail.body" :label="$t('label.message')" hide-details />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider class="my-3" />
        <v-card-actions>
          <v-btn @click="sendTestEmail">{{ $t('btn.sendTestEmail') }}</v-btn>
          <v-spacer />
          <v-btn color="colorSave" @click="dataSave">{{ $t('btn.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackHandler" :timeout="2000" top color="green">{{ snackMessage }}</v-snackbar>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';

import { mdiClose, mdiCheck, mdiThermometer, mdiClipboard } from '@mdi/js';

export default Vue.extend({
  name: 'SettingsGlobal',
  data: () => ({
    importFile: '',
    importFileName: '',
    importEvent: 'append',
    importProgressStatus: false,
    testEmail: {
      to: '',
      subject: '',
      body: '',
    },
    modalImport: false,
    dialogLicenseString: false,
    dialogSMTP: false,
    settings: {
      usrDef1name: '',
      usrDef2name: '',
      usrDef3name: '',
      usrDef4name: '',
      mobileGateway: '',
      apiEnabled: false,
      apiToken: '',
      installUUID: '',
      licenseString: '',
      autoOrgID: false,
      telemetry: false,
      temperature: '37.00',
      language: 'en',
      formatDate: '',
      formatTime: '',
      firstDay: 0,
      timezone: 'Europe/Prague',
      checkDocumentValidity: false,
      autoSaveVisitors: false,
      autoSaveCompanies: false,
      autoSaveCars: false,
      planVisits: false,
      licWorkplaces: 0,
      licPlanning: false,
      licExpiresAt: 0,
      smtpServer: '',
      smtpPort: 0,
      smtpTLS: '',
      smtpTLSvalid: false,
      smtpAuth: '',
      smtpUser: '',
      smtpPassword: '',
      smtpSender: '',
      smtpEnabled: false,
      publicServerAddress: '',
    },
    listLanguages: [],
    listTimezones: [],
    listDateFormats: [
      { text: '21.12.2021', value: 'DD.MM.YYYY' },
      { text: '21/12/2021', value: 'DD/MM/YYYY' },
      { text: '21-12-2021', value: 'DD-MM-YYYY' },
      { text: '2021-12-21', value: 'YYYY-MM-DD' },
      { text: '2021/12/21', value: 'YYYY/MM/DD' },
    ],
    listTimeFormats: [
      { text: '16:23', value: 'HH:mm' },
      { text: '04:23pm', value: 'hh:mmA' },
    ],
    listTemperatures: [
      { text: '37.0 C', value: '37.00' },
      { text: '37.2 C', value: '37.20' },
      { text: '37.4 C', value: '37.40' },
      { text: '37.6 C', value: '37.60' },
      { text: '37.8 C', value: '37.80' },
      { text: '38.0 C', value: '38.00' },
    ],
    listTLS: [
      { text: 'disabled', value: '' },
      { text: 'TLS', value: 'TLS' },
      { text: 'StartTLS', value: 'StartTLS' },
    ],
    listAuth: [
      { text: 'disabled', value: '' },
      { text: 'PLAIN', value: 'PLAIN' },
      { text: 'LOGIN', value: 'LOGIN' },
    ],
    snackHandler: false,
    snackMessage: '' as any,
    mdiClose: mdiClose,
    mdiThermometer: mdiThermometer,
    mdiCheck: mdiCheck,
    mdiClipboard: mdiClipboard,
  }),
  computed: {
    listImportEvents: function () {
      return [
        { text: this.$i18n.t('label.append'), value: 'append' },
        { text: this.$i18n.t('label.rewrite'), value: 'rewrite' },
      ];
    },
    listFirstDayOfWeek: function () {
      return [
        { text: this.$i18n.t('label.sunday'), value: 0 },
        { text: this.$i18n.t('label.monday'), value: 1 },
      ];
    },
  },
  mounted() {
    this.listLanguagesLoad();
    this.listTimezonesLoad();
    this.dataLoad();
  },
  methods: {
    dataLoad() {
      axios
        .get('/api/v1/settings')
        .then((response) => {
          this.settings = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    dataSave() {
      axios
        .put('/api/v1/settings', this.settings)
        .then(() => {
          this.$store.dispatch('getSettings');
          this.snackMessage = this.$i18n.t('msg.settingsSaved');
          this.snackHandler = true;
          this.dataLoad();
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    uploadArchive() {
      if (this.importFileName === '') {
        this.$store.commit('globalMessage', this.$i18n.t('msg.selectImportFile'));
        return;
      }
      this.importProgressStatus = true;
      const formData = new FormData();
      formData.append('upload', this.importFile[0]);
      axios
        .post(`/api/v1/import/archive/${this.importEvent}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(() => {
          this.importProgressStatus = false;
          this.modalImport = false;
        })
        .catch((err) => {
          this.importProgressStatus = false;
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    generateToken() {
      const length = 128;
      this.settings.apiToken = '';
      var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        this.settings.apiToken += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
    },
    copyTokenToClipboard() {
      const el = document.createElement('textarea');
      el.value = this.settings.apiToken;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.snackHandler = true;
      this.snackMessage = this.$i18n.t('msg.savedToClipboard');
    },
    copyToClipboard(textToCopy: string) {
      navigator.clipboard.writeText(textToCopy).then(
        () => {
          this.$store.commit('globalMessage', this.$i18n.t('msg.savedToClipboard'));
        },
        (err) => {
          this.$store.dispatch('catchErrHandler', err);
        },
      );
    },
    sendTestEmail() {
      axios
        .post('/api/v1/testemail', this.testEmail)
        .then(() => {
          this.snackMessage = this.$i18n.t('msg.emailSent');
          this.snackHandler = true;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    listLanguagesLoad() {
      axios
        .get('/api/v1/languages')
        .then((response) => {
          this.listLanguages = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    listTimezonesLoad() {
      axios
        .get('/api/v1/timezones')
        .then((response) => {
          this.listTimezones = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    licTimecalc() {
      return this.$moment(this.settings.licExpiresAt * 1000).format(this.$store.state.auth.df.date);
    },
  },
});
</script>
